import { useEffect, useState } from 'react';

/**
 * The current time, re-read every `everyMs` and when the tab comes back, so a
 * list left open still re-labels what has since become overdue. Pair with
 * useEasternToday, which does the same for the calendar date.
 */
export const useNow = (everyMs = 60_000) => {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    const tick = () => setNow(new Date());
    const intervalId = window.setInterval(tick, everyMs);
    window.addEventListener('focus', tick);
    document.addEventListener('visibilitychange', tick);
    return () => {
      window.clearInterval(intervalId);
      window.removeEventListener('focus', tick);
      document.removeEventListener('visibilitychange', tick);
    };
  }, [everyMs]);

  return now;
};
